"use client";

import { useEffect, type ReactNode } from "react";
import { usePathname, useRouter } from "next/navigation";

import { useCurrentUser } from "@/hooks/use-current-user";
import { isNativeApp, isNativeBlockedPath } from "@/lib/native/platform";

export function NativeAppGuard({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const router = useRouter();
  const currentUserQuery = useCurrentUser();

  useEffect(() => {
    if (!isNativeApp()) {
      return;
    }

    if (isNativeBlockedPath(pathname)) {
      router.replace(currentUserQuery.data ? "/" : "/login");
      return;
    }

    if (
      pathname === "/" &&
      !currentUserQuery.isLoading &&
      !currentUserQuery.data
    ) {
      router.replace("/login");
    }
  }, [
    pathname,
    router,
    currentUserQuery.data,
    currentUserQuery.isLoading,
  ]);

  return <>{children}</>;
}
